import React, { useContext, useState } from 'react';
import { Outlet, useParams } from 'react-router';
import { useLocation } from 'react-router-dom';

import Config from '@skin_config';
import { UIContext } from '@app/dev/contexts/ui';
import { configTypeMap } from '../components/eventTypeFilter/constants';
import EventTypeFilter from '../components/eventTypeFilter';

const BettingLayout = () => {
  const {
    listType,
    sportAlias,
  } = useParams();
  const [searchText, setSearchText] = useState('');
  const [{ theme }] = useContext(UIContext);
  const location = useLocation();

  const notNestedVirtualsCheck = Config.routes.find((item) => item.type === 'virtuals');

  const isVirtuals = (listType === 'virtuals' || location.pathname.includes('virtual-results')) && notNestedVirtualsCheck;

  const configType = isVirtuals ? configTypeMap.virtuals : configTypeMap.sportsBook;

  return (
    <div className={`import-view-container asian-view with-type-filter sportsbook-theme-${theme}`}>
      <EventTypeFilter
        listType={listType}
        gameType="prematch"
        sportAlias={sportAlias}
        searchText={searchText}
        setSearchText={setSearchText}
        configType={configType}
      />

      <Outlet context={[searchText, setSearchText]} />
    </div>
  );
};

export default BettingLayout;
